import { render, staticRenderFns } from "./PupilLogin.vue?vue&type=template&id=47946848&scoped=true"
import script from "./PupilLogin.vue?vue&type=script&lang=ts"
export * from "./PupilLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47946848",
  null
  
)

export default component.exports